import { render, staticRenderFns } from "./importFile.vue?vue&type=template&id=0abf9980&scoped=true"
import script from "./importFile.vue?vue&type=script&lang=js"
export * from "./importFile.vue?vue&type=script&lang=js"
import style0 from "./importFile.vue?vue&type=style&index=0&id=0abf9980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abf9980",
  null
  
)

export default component.exports